import { ActiveUser } from "@/type/core/auth/auth.types";
import { EcUserDTO } from "@/type/core/user/EcUserDTO";
import DateFormat from "@utils/DateFormat";

export class UserHelper {
  static updateRevokeCertificateInfos(
    activeUser: ActiveUser,
    ecUserDTO: EcUserDTO,
  ): ActiveUser {
    return {
      ...activeUser,
      certificateInfos: {
        ...activeUser.certificateInfos,
        serialNumber: ecUserDTO.tsCertificateSerialNumber,
        revocationDate: DateFormat.certificateDate(
          ecUserDTO.tsCertificateRevocationDate,
        ),
      },
      usCertificateStatus: ecUserDTO.universignCertificateStatus,
      usExpirationDate: DateFormat.certificateDate(
        ecUserDTO.universignCertificateStatusModificationDate,
      ),
      onboardingError: ecUserDTO.onboardingError,
      tsCertificateStatus: ecUserDTO.tsCertificateStatus,
    };
  }
}
